// Besucherstatistik mit Umami (selbst gehostet, ohne Cookies)
// Skript und Tracking laufen first-party über drunkenhippos.de/insights/ (Caddy -> Umami).
// Geladen wird nur im Production-Build und nur, wenn eine Website-ID gesetzt ist.

interface UmamiTracker {
  track: (payload?: (props: Record<string, unknown>) => Record<string, unknown>) => void;
}

declare global {
  interface Window {
    umami?: UmamiTracker;
  }
}

const WEBSITE_ID = import.meta.env.VITE_UMAMI_WEBSITE_ID ?? '';
const HOST_URL = '/insights';
const DOMAINS = 'drunkenhippos.de,www.drunkenhippos.de';

export const analyticsEnabled = import.meta.env.PROD && !!WEBSITE_ID;

// Seiten, die nie gezählt werden (Admin-Besuche verfälschen die Statistik)
const isExcluded = (path: string) => path.startsWith('/admin');

let loaded = false;
let pending: string | null = null;

const send = (path: string) => {
  window.umami?.track((props) => ({ ...props, url: path }));
};

export function loadUmami(): void {
  if (!analyticsEnabled || document.getElementById('umami-script')) return;

  const script = document.createElement('script');
  script.id = 'umami-script';
  script.defer = true;
  script.src = `${HOST_URL}/script.js`;
  script.dataset.websiteId = WEBSITE_ID;
  script.dataset.hostUrl = HOST_URL;
  script.dataset.domains = DOMAINS;
  // Seitenaufrufe melden wir selbst über den Router, damit /admin ausgelassen wird
  script.dataset.autoTrack = 'false';
  script.onload = () => {
    loaded = true;
    if (pending) send(pending);
    pending = null;
  };
  document.head.appendChild(script);
}

export function trackPageview(path: string): void {
  if (!analyticsEnabled || isExcluded(path)) return;
  if (loaded) {
    send(path);
  } else {
    // Erster Aufruf kommt oft, bevor das Skript geladen ist
    pending = path;
  }
}
